import {FlowNodeData, FlowNodeTypes, SettingParamTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const entryNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.ENTRY,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: FlowNodeTypes.ENTRY,
    settingsTitle: "Entry Triggers",
    nodeTitle: "Entry Triggers",
    onChange: () => {
      console.log("Entry node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "Triggers",
        icon: "Settings2",
        description:
          "Specify under what conditions this flow should be activated.",
        params: [
          {
            type: SettingParamTypes.MULTIPLE,
            key: "triggers",
            value: [],
            settings: [
              {
                placeholder: "Trigger",
                type: SettingParamTypes.INPUT,
                key: "trigger",
                value: "",
              },
            ],
          },
        ],
      },
    ],
  },
};
